export const toFeetInch = (cm) =>{
  if (!cm || isNaN(cm)) return '-';
  const totalInches = Math.round(cm / 2.54);
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return `${feet}'${inches}"`;
}
export const sanitizePhoneNumber = (value) => {
  return value
    .replace(/(?!^)\+/g, '')
    .replace(/[^+\d]/g, '');
};
export const allowPhoneCharacters = (event) => {
  const { value, selectionStart } = event.target;

  if (event.key === '+') {
    if (selectionStart !== 0 || value.includes('+')) {
      event.preventDefault();
    }
    return;
  }

  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};
export const allowOnlyDigits = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};